import WidgetLoadingSkeleton from "./widgetLoadingSkeleton";

export default WidgetLoadingSkeleton;